/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { NbAuthModule, NbPasswordAuthStrategy, NbAuthJWTToken } from '@nebular/auth';
import { MyInterceptor } from './services/interceptor';
import { AuthGuard } from './services/auth-guard.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          baseEndpoint: '//trinetti.co:3300',
           login: {

             endpoint: '/login',
             method: 'post',
             redirect: {
              success: '/pages/napi_forgalom',
              failure: null, // stay on the same page
            },
            defaultErrors: ['Helytelen email vagy jelszó!'],
            defaultMessages: ['Sikeres bejelentkezés'],
           },
           token: {
            class: NbAuthJWTToken,
            key: 'token',
          },
          logout: { method: null, redirect: { success: '/auth/login', failure: '/auth/login' } },
          }),
          ],
      forms: {},
        }),
    NgbModule,
    ],
    bootstrap: [AppComponent],
    providers: [
      { provide: HTTP_INTERCEPTORS, useClass: MyInterceptor, multi: true },
      AuthGuard
    ],
    })

export class AppModule {
}
